import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=2be7e8a0"
import script from "./Tariff.vue?vue&type=script&setup=true&lang=js"
export * from "./Tariff.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports